import "@/styles/globals.css";
import type { AppProps } from "next/app";
// app/layout.tsx or pages/_app.tsx
import { Poppins } from "@next/font/google";
import { AuthProvider } from "@/context/AuthContext";
import { useEffect } from "react";
import Head from "next/head";
import InstallPrompt from "@/components/layouts/InstallPrompt";
const poppins = Poppins({
  variable: "--font-poppins-sans",
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
});

export default function App({ Component, pageProps }: AppProps) {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/service-worker.js")
          .then((registration) => {
            console.log(
              "Service Worker registered with scope:",
              registration.scope
            );
          })
          .catch((error) => {
            console.error("Service Worker registration failed:", error);
          });
      });
    }
  }, []);

  return (
    <AuthProvider>
      <Head>
        <title>Tarum Absen</title>
      </Head>
      <div className={poppins.variable}>
        <InstallPrompt />
        <Component {...pageProps} />
      </div>
    </AuthProvider>
  );
}
